// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3FAPo","modal":"Modal_modal__P3_V5","content":"Modal_content__1VIbZ","closeButton":"Modal_closeButton__840KP"};